import R from "ramda";
import { validate as validateEmail } from "email-validator";
import { SEARCH_UNIVERSE, RECOMMENDABLE_TYPE } from "./constants";
import { CONTACT_TYPE } from "../contacts/contactsModels";
import { hasNoDerivativeDescription } from "./models";

function isDateTimeValid(value) {
    return R.isNil(value) || (value.instant !== null);
}

export function allContactEmailsAreValid(contacts) {
    const result = contacts.reduce((acc, contact) => {
        if (contact.type === CONTACT_TYPE.ADDRESS) {
            return acc && validateEmail(contact.emailAddress)
        }
        return acc;
    }, true);
    return result;
}

export function isRequired(value) {
    return !(value === undefined || value === null || value.length === 0);
}

export function validateField(fields, key, errors, predicate) {
    if (!predicate(fields[key])) {
        errors[key] = "invalid";
        return false;
    }
    return true;
}

export function validateList(fields, key, errors, fieldValidation) {
    errors[key] = [];
    fields[key].forEach( (field, index) => {
        const fieldErrors = {};
        errors[key][index] = fieldErrors;
        fieldValidation(field, fieldErrors);
    });
}

export function validateObject(fields, key, errors, fieldValidation) {
    const fieldErrors = {};
    fieldValidation(fields[key], fieldErrors);
    if (Object.keys(fieldErrors).length > 0) {
        errors[key] = fieldErrors;
    }
}

function marketPriceIsRequiredFor(leg) {
    const recommendableType = leg.instrument.recommendableType;

    return recommendableType === RECOMMENDABLE_TYPE.BOND ||
           recommendableType === RECOMMENDABLE_TYPE.INTEREST_RATE_FUTURE ||
           recommendableType === RECOMMENDABLE_TYPE.FX_PAIR ||
           (recommendableType === RECOMMENDABLE_TYPE.EQUITY && !hasNoDerivativeDescription(leg.derivativeDescription));
}

function descriptionIsRequiredFor(leg) {
    if (!leg.instrument) {
        return false;
    }

    const recommendableType = leg.instrument.recommendableType;
    return (recommendableType === RECOMMENDABLE_TYPE.INTEREST_RATE_FUTURE || recommendableType === RECOMMENDABLE_TYPE.FX_PAIR);
}

export function validateRecorderForm(fields) {
    const errors = {};
    validateField(fields, "communicatedVia", errors, isRequired);
    validateField(fields, "disseminatedOn", errors, isDateTimeValid);
    validateField(fields, "clients", errors, isRequired)
        && validateField(fields, "clients", errors, allContactEmailsAreValid)
        && validateList(fields, "clients", errors, (client, clientErrors) => {});

    validateList(fields, "recommendations", errors, (recommendation, recommendationErrors) => {
        validateField(recommendation, "hasConflictOfInterest", recommendationErrors, isRequired);
        if (recommendation.hasConflictOfInterest === "yes") {
            validateField(recommendation, "conflictOfInterestDescription", recommendationErrors, isRequired);
        }

        validateField(recommendation, "producedOn", recommendationErrors, isDateTimeValid);

        recommendation.legs && (recommendation.legs.length > 0) && validateList(recommendation, "legs", recommendationErrors, (leg, legErrors) => {
            validateField(leg, "direction", legErrors, isRequired);

            if (marketPriceIsRequiredFor(leg)) {
                validateField(leg, "suppliedPrice", legErrors, isRequired);
            }

            leg.instrument && validateObject(leg, "instrument", legErrors, (instrument, instrumentErrors) => {
                validateField(instrument, "instrumentId", instrumentErrors, isRequired);
            });

            if (descriptionIsRequiredFor(leg)) {
                validateField(leg, "derivativeDescription", legErrors, isRequired);
            }
        });
    });

    return errors;
}



/** WEBPACK FOOTER **
 ** ./src/main/javascript/recorder/recorderValidations.js
 **/